/** Base pathname for common menu APIs. */
export const MENU_BASE_PATH = '/menu';

export const MENU_ENDPOINTS = {
  top: `${MENU_BASE_PATH}/top`,
  left: (menuId: string | number) => `${MENU_BASE_PATH}/left/${menuId}`,
  routes: `${MENU_BASE_PATH}/routes`,
  permissions: (pageId: string | number) => `${MENU_BASE_PATH}/permissions/${pageId}`,
  tab: (pageId: string | number) => `${MENU_BASE_PATH}/tab/${pageId}`,
} as const;
